import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { useEffect, useRef, useState } from "react";
import Toast from "../../Utility/Toast";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        alignItems: "center",
        maxWidth: 180,
    },
    tooltip: {
        backgroundColor: "#4a4a4a",
        opacity: 1,
        fontSize: 12,
        color: "#fff",
    },
    arrow: {
        color: "#4a4a4a",
    },
    ellipsis: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        cursor: "default",
    },
    copyButton: {
        padding: 2,
        marginLeft: 4,
        flexShrink: 0,
    },
}));

const CustomTooltip = ({ children }) => {
    const classes = useStyles();
    const textRef = useRef<HTMLDivElement | null>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        };
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [children]);

    const handleCopy = async (event: React.MouseEvent) => {
        event.stopPropagation();
        try {
            await navigator.clipboard.writeText(String(children ?? ""));
        } catch {
            Toast.error("Failed to copy");
        }
    };

    return (
        <div className={classes.container}>
            <Tooltip title={isOverflowing ? children : ""} classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}>
                <div ref={textRef} className={classes.ellipsis}>
                    {children}
                </div>
            </Tooltip>
            {isOverflowing && (
                <IconButton
                    size="small"
                    className={classes.copyButton}
                    onClick={handleCopy}
                >
                    <FileCopyOutlinedIcon fontSize="small" />
                </IconButton>
            )}
        </div>
    );
};

export default CustomTooltip;
